import axios from "axios";
const client = axios.create({
  responseType: "json"
});
async function getPortalUserById(userId, signal) {
  return client.get(`/company-user/${userId}`, { signal }).then((response) => response.data);
}
async function getOwnPortalUser(signal) {
  return client.get("/company-user/me", { signal }).then((response) => response.data);
}
async function getPortalUsers(params, signal) {
  return client.get("/company-user", { params, signal }).then((response) => response.data);
}
async function addPortalUser(request, signal) {
  return client.post("/company-user", request, { signal }).then((response) => response.data);
}
async function updatePortalUser(userId, request, signal) {
  return client.patch(`/company-user/${userId}`, request, { signal }).then((response) => response.data);
}
async function updateOwnPortalUser(request, signal) {
  return client.patch("/company-user/me", request, { signal }).then((response) => response.data);
}
async function deletePortalUser(userId, signal) {
  return client.delete(`/company-user/${userId}`, { signal }).then((response) => response.data);
}
async function updatePortalUserRole(userId, request, signal) {
  return client.patch(`/company-user/${userId}`, request, { signal }).then((response) => response.data);
}
async function validatePortalUserEmail(code, signal) {
  return client.post("/company-user/email/validate", null, {
    params: { code },
    signal
  });
}
async function resendPortalUserValidationEmail(userId, signal) {
  return client.post(`/company-user/${userId}/email/validate`, null, {
    signal
  });
}
async function resendOwnPortalUserValidationEmail(signal) {
  return client.post(`/company-user/me/email/validate`, null, { signal });
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
      var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
      return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
    } }, m = function(t2, e2, n2) {
      var r2 = String(t2);
      return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
    }, v = { s: m, z: function(t2) {
      var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
      return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
    }, m: function t2(e2, n2) {
      if (e2.date() < n2.date())
        return -t2(n2, e2);
      var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
      return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
    }, a: function(t2) {
      return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
    }, p: function(t2) {
      return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t2) {
      return void 0 === t2;
    } }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t2) {
      return t2 instanceof _ || !(!t2 || !t2[p]);
    }, w = function t2(e2, n2, r2) {
      var i2;
      if (!e2)
        return g;
      if ("string" == typeof e2) {
        var s2 = e2.toLowerCase();
        D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
        var u2 = e2.split("-");
        if (!i2 && u2.length > 1)
          return t2(u2[0]);
      } else {
        var a2 = e2.name;
        D[a2] = e2, i2 = a2;
      }
      return !r2 && i2 && (g = i2), i2 || !r2 && g;
    }, O = function(t2, e2) {
      if (S(t2))
        return t2.clone();
      var n2 = "object" == typeof e2 ? e2 : {};
      return n2.date = t2, n2.args = arguments, new _(n2);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t2, e2) {
      return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
    };
    var _ = function() {
      function M2(t2) {
        this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
      }
      var m2 = M2.prototype;
      return m2.parse = function(t2) {
        this.$d = function(t3) {
          var e2 = t3.date, n2 = t3.utc;
          if (null === e2)
            return /* @__PURE__ */ new Date(NaN);
          if (b.u(e2))
            return /* @__PURE__ */ new Date();
          if (e2 instanceof Date)
            return new Date(e2);
          if ("string" == typeof e2 && !/Z$/i.test(e2)) {
            var r2 = e2.match($);
            if (r2) {
              var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t2), this.init();
      }, m2.init = function() {
        var t2 = this.$d;
        this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
      }, m2.$utils = function() {
        return b;
      }, m2.isValid = function() {
        return !(this.$d.toString() === l);
      }, m2.isSame = function(t2, e2) {
        var n2 = O(t2);
        return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
      }, m2.isAfter = function(t2, e2) {
        return O(t2) < this.startOf(e2);
      }, m2.isBefore = function(t2, e2) {
        return this.endOf(e2) < O(t2);
      }, m2.$g = function(t2, e2, n2) {
        return b.u(t2) ? this[e2] : this.set(n2, t2);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t2, e2) {
        var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
          var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
          return r2 ? i2 : i2.endOf(a);
        }, $2 = function(t3, e3) {
          return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
        switch (f2) {
          case h:
            return r2 ? l2(1, 0) : l2(31, 11);
          case c:
            return r2 ? l2(1, M3) : l2(0, M3 + 1);
          case o:
            var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
            return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
          case a:
          case d:
            return $2(v2 + "Hours", 0);
          case u:
            return $2(v2 + "Minutes", 1);
          case s:
            return $2(v2 + "Seconds", 2);
          case i:
            return $2(v2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t2) {
        return this.startOf(t2, false);
      }, m2.$set = function(t2, e2) {
        var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === c || o2 === h) {
          var y2 = this.clone().set(d, 1);
          y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
        } else
          l2 && this.$d[l2]($2);
        return this.init(), this;
      }, m2.set = function(t2, e2) {
        return this.clone().$set(t2, e2);
      }, m2.get = function(t2) {
        return this[b.p(t2)]();
      }, m2.add = function(r2, f2) {
        var d2, l2 = this;
        r2 = Number(r2);
        var $2 = b.p(f2), y2 = function(t2) {
          var e2 = O(l2);
          return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
        };
        if ($2 === c)
          return this.set(c, this.$M + r2);
        if ($2 === h)
          return this.set(h, this.$y + r2);
        if ($2 === a)
          return y2(1);
        if ($2 === o)
          return y2(7);
        var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return b.w(m3, this);
      }, m2.subtract = function(t2, e2) {
        return this.add(-1 * t2, e2);
      }, m2.format = function(t2) {
        var e2 = this, n2 = this.$locale();
        if (!this.isValid())
          return n2.invalidDate || l;
        var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
          return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
        }, d2 = function(t3) {
          return b.s(s2 % 12 || 12, t3, "0");
        }, $2 = f2 || function(t3, e3, n3) {
          var r3 = t3 < 12 ? "AM" : "PM";
          return n3 ? r3.toLowerCase() : r3;
        };
        return r2.replace(y, function(t3, r3) {
          return r3 || function(t4) {
            switch (t4) {
              case "YY":
                return String(e2.$y).slice(-2);
              case "YYYY":
                return b.s(e2.$y, 4, "0");
              case "M":
                return a2 + 1;
              case "MM":
                return b.s(a2 + 1, 2, "0");
              case "MMM":
                return h2(n2.monthsShort, a2, c2, 3);
              case "MMMM":
                return h2(c2, a2);
              case "D":
                return e2.$D;
              case "DD":
                return b.s(e2.$D, 2, "0");
              case "d":
                return String(e2.$W);
              case "dd":
                return h2(n2.weekdaysMin, e2.$W, o2, 2);
              case "ddd":
                return h2(n2.weekdaysShort, e2.$W, o2, 3);
              case "dddd":
                return o2[e2.$W];
              case "H":
                return String(s2);
              case "HH":
                return b.s(s2, 2, "0");
              case "h":
                return d2(1);
              case "hh":
                return d2(2);
              case "a":
                return $2(s2, u2, true);
              case "A":
                return $2(s2, u2, false);
              case "m":
                return String(u2);
              case "mm":
                return b.s(u2, 2, "0");
              case "s":
                return String(e2.$s);
              case "ss":
                return b.s(e2.$s, 2, "0");
              case "SSS":
                return b.s(e2.$ms, 3, "0");
              case "Z":
                return i2;
            }
            return null;
          }(t3) || i2.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d2, l2) {
        var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
          return b.m(y2, m3);
        };
        switch (M3) {
          case h:
            $2 = D2() / 12;
            break;
          case c:
            $2 = D2();
            break;
          case f:
            $2 = D2() / 3;
            break;
          case o:
            $2 = (g2 - v2) / 6048e5;
            break;
          case a:
            $2 = (g2 - v2) / 864e5;
            break;
          case u:
            $2 = g2 / n;
            break;
          case s:
            $2 = g2 / e;
            break;
          case i:
            $2 = g2 / t;
            break;
          default:
            $2 = g2;
        }
        return l2 ? $2 : b.a($2);
      }, m2.daysInMonth = function() {
        return this.endOf(c).$D;
      }, m2.$locale = function() {
        return D[this.$L];
      }, m2.locale = function(t2, e2) {
        if (!t2)
          return this.$L;
        var n2 = this.clone(), r2 = w(t2, e2, true);
        return r2 && (n2.$L = r2), n2;
      }, m2.clone = function() {
        return b.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), k = _.prototype;
    return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function(t2) {
      k[t2[1]] = function(e2) {
        return this.$g(e2, t2[0], t2[1]);
      };
    }), O.extend = function(t2, e2) {
      return t2.$i || (t2(e2, _, O), t2.$i = true), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
      return O(1e3 * t2);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
  });
})(dayjs_min);
var dayjs_minExports = dayjs_min.exports;
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
async function getTeleSignLogs(params, signal) {
  return client.get("/telesign", {
    params: {
      ...params,
      fromDate: (params == null ? void 0 : params.fromDate) ? dayjs(params.fromDate).format("YYYY-MM-DD") : null,
      toDate: (params == null ? void 0 : params.toDate) ? dayjs(params.toDate).format("YYYY-MM-DD") : null
    },
    signal
  }).then((response) => response.data);
}
async function startTeleSign(request, signal) {
  return client.post("/telesign", request, { signal }).then((response) => response.data);
}
async function cancelTeleSign(id, signal) {
  return client.delete(`/telesign/${id}`, {
    signal
  }).then((response) => response.data);
}
async function getTeleSignStatus(id, signal) {
  return client.get(`/telesign/${id}`, { signal }).then((response) => response.data);
}
async function downloadTeleSignPdf(id, signal) {
  return client.get(`/telesign/${id}/pdf`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function startTeleSignSigning(id, signal) {
  return client.post(`/telesign/${id}/sign`, { signal }).then((response) => response.data);
}
async function getTeleSignSigningStatus(id, signal) {
  return client.get(`/telesign/${id}/sign`, { signal }).then((response) => response.data);
}
var AuthMethod = /* @__PURE__ */ ((AuthMethod2) => {
  AuthMethod2["SSN"] = "SSN";
  AuthMethod2["SMS"] = "SMS";
  AuthMethod2["EMAIL"] = "EMAIL";
  AuthMethod2["CHAT"] = "CHAT";
  return AuthMethod2;
})(AuthMethod || {});
var CallInitiator = /* @__PURE__ */ ((CallInitiator2) => {
  CallInitiator2["USER"] = "USER";
  CallInitiator2["RP"] = "RP";
  return CallInitiator2;
})(CallInitiator || {});
async function getTeleIdLogs(params, signal) {
  return client.get("/teleid", {
    params: {
      ...params,
      fromDate: (params == null ? void 0 : params.fromDate) ? dayjs(params.fromDate).format("YYYY-MM-DD") : null,
      toDate: (params == null ? void 0 : params.toDate) ? dayjs(params.toDate).format("YYYY-MM-DD") : null
    },
    signal
  }).then((response) => response.data);
}
async function startTeleId(request, signal) {
  return client.post("/teleid", request, { signal }).then((response) => response.data);
}
async function cancelTeleId(id, signal) {
  return client.delete(`/teleid/${id}`, {
    signal
  }).then((response) => response.data);
}
async function getTeleIdStatus(id, signal) {
  return client.get(`/teleid/${id}`, { signal }).then((response) => response.data);
}
async function startTeleIdAuth(id, signal) {
  return client.post(`/teleid/${id}/auth`, { signal }).then((response) => response.data);
}
async function getTeleIdAuthStatus(id, signal) {
  return client.get(`/teleid/${id}/auth`, { signal }).then((response) => response.data);
}
async function getStatsParams(signal) {
  return client.get("/stat/params", { signal }).then((response) => response.data);
}
async function searchStats(filter, signal) {
  return client.get("/stat/search", {
    params: {
      startDate: (filter == null ? void 0 : filter.startDate) ? dayjs(filter.startDate).format("YYYY-MM-DD") : void 0,
      endDate: (filter == null ? void 0 : filter.endDate) ? dayjs(filter.endDate).format("YYYY-MM-DD") : void 0,
      service: filter == null ? void 0 : filter.service,
      customerName: filter == null ? void 0 : filter.customerName,
      country: filter == null ? void 0 : filter.country,
      provider: filter == null ? void 0 : filter.provider,
      customerType: filter == null ? void 0 : filter.customerType
    },
    signal
  }).then((response) => response.data);
}
async function exportStats(filter, signal) {
  return client.get("/stat/excel", {
    responseType: "blob",
    params: {
      startDate: (filter == null ? void 0 : filter.startDate) ? dayjs(filter.startDate).format("YYYY-MM-DD") : void 0,
      endDate: (filter == null ? void 0 : filter.endDate) ? dayjs(filter.endDate).format("YYYY-MM-DD") : void 0,
      service: filter == null ? void 0 : filter.service,
      customerName: filter == null ? void 0 : filter.customerName,
      country: filter == null ? void 0 : filter.country,
      provider: filter == null ? void 0 : filter.provider,
      customerType: filter == null ? void 0 : filter.customerType
    },
    signal
  }).then((response) => response.data);
}
var SafeMailStatus = /* @__PURE__ */ ((SafeMailStatus2) => {
  SafeMailStatus2["NEW"] = "New";
  SafeMailStatus2["PROCESSING"] = "Processing";
  SafeMailStatus2["DONE"] = "Done";
  return SafeMailStatus2;
})(SafeMailStatus || {});
async function getSafeMailPopulateData(ssn, country, signal) {
  return client.get(`/message/enduser`, {
    params: {
      ssn,
      country
    },
    signal
  }).then((response) => response.data);
}
async function getSafeMailInboxMessageAttachment(messageId, signal) {
  return client.get(`/attachment/inbox/${messageId}`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function getSafeMailSentMessageAttachment(messageId, signal) {
  return client.get(`/attachment/sent/${messageId}`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function sendMessage(request, signal) {
  const data = new FormData();
  for (const [key, value] of Object.entries(request)) {
    if (value) {
      if (value instanceof File) {
        data.append(key, value);
      } else {
        data.append(key, String(value));
      }
    }
  }
  return client.post("/message", data, { signal }).then((response) => response.data);
}
async function addRecipients(messageId, recipients, signal) {
  return client.post(
    `/message/${messageId}/recipients`,
    {
      recipients
    },
    { signal }
  ).then((response) => response.data);
}
async function getSafeMailOutboxMessages(params, signal) {
  return client.get("/message", { params, signal }).then((response) => response.data);
}
async function getSafeMailInboxMessages(params, signal) {
  var _a;
  return client.get("/message/inbox", {
    params: {
      ...params,
      status: (_a = params == null ? void 0 : params.status) == null ? void 0 : _a.join(",")
    },
    signal
  }).then((response) => response.data);
}
async function changeSafeMailInboxMessageStatus(messageId, status, signal) {
  return client.post(`/message/inbox/${messageId}/status/${status}`, null, {
    signal
  }).then((response) => response.data);
}
async function deleteSafeMailInboxMessages(messageIds, signal) {
  return client.post(
    "/message/inbox/delete",
    {
      ids: messageIds
    },
    { signal }
  ).then((response) => response.data);
}
async function deleteSafeMailSentMessages(messageIds, signal) {
  return client.post(
    "/message/delete",
    {
      ids: messageIds
    },
    { signal }
  ).then((response) => response.data);
}
async function getSafeMailInboxPdf(messageId, signal) {
  return client.get(`/message/inbox/${messageId}/pdf`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function startSafeMailInboxPdfExport(params, signal) {
  var _a;
  return client.post("/safemail/inbox/pdf-export", null, {
    params: {
      ...params,
      status: (_a = params == null ? void 0 : params.status) == null ? void 0 : _a.join(",")
    },
    signal
  }).then((response) => response.data);
}
async function getSafeMailInboxPdfExport(id, signal) {
  return client.get(`/safemail/inbox/pdf-export/${id}`, { signal }).then((response) => response.data);
}
async function getSafeMailInboxPdfExportResult(id, signal) {
  return client.get(`/safemail/inbox/pdf-export/${id}/result`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function startSafeMailInboxExcelExport(params, signal) {
  var _a;
  return client.post("/safemail/inbox/excel-export", null, {
    params: {
      ...params,
      status: (_a = params == null ? void 0 : params.status) == null ? void 0 : _a.join(",")
    },
    signal
  }).then((response) => response.data);
}
async function getSafeMailInboxExcelExport(id, signal) {
  return client.get(`/safemail/inbox/excel-export/${id}`, { signal }).then((response) => response.data);
}
async function getSafeMailInboxExcelExportResult(id, signal) {
  return client.get(`/safemail/inbox/excel-export/${id}/result`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function startSafeMailOutboxExcelExport(signal) {
  return client.post("/safemail/outbox/excel-export", null, { signal }).then((response) => response.data);
}
async function getSafeMailOutboxExcelExport(id, signal) {
  return client.get(`/safemail/outbox/excel-export/${id}`, { signal }).then((response) => response.data);
}
async function getSafeMailOutboxExcelExportResult(id, signal) {
  return client.get(`/safemail/outbox/excel-export/${id}/result`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function getOwnPrivateUser(signal) {
  return client.get("/private/user/me", { signal }).then((response) => response.data);
}
async function updateOwnPrivateUserEmail(email, signal) {
  return client.put("/private/user/email", email, {
    headers: {
      "Content-Type": "text/plain"
    },
    signal
  }).then((response) => response.data);
}
async function acceptPrivateAppTermsOfServices(signal) {
  return client.put("/private/user/termsofservice", null, { signal }).then((response) => response.data);
}
async function deleteOwnPrivateUser(signal) {
  return client.delete("/private/user/me", { signal }).then((response) => response.data);
}
async function initCheckout(request, signal) {
  return client.post("/private/checkout", request, { signal }).then((response) => response.data);
}
async function createAuthRequest(request, signal) {
  return client.post("/private/auth-request", request, { signal }).then((response) => response.data);
}
async function deleteAuthRequest(id, signal) {
  return client.delete(`/private/auth-request/${id}`, { signal }).then((response) => response.data);
}
async function getAuthRequests(signal) {
  return client.get(`/private/auth-request`, { signal }).then((response) => response.data);
}
async function swedenPrivateLogin(signal) {
  return client.post(`/private/sweden/login`, {}, { signal }).then((response) => response.data);
}
async function getPrivateLoginResult(id, signal) {
  return client.get(`/private/sweden/login/${encodeURIComponent(id)}`, { signal }).then((response) => response.data);
}
async function initPrivateNorwayLogin(signal) {
  return client.get("/private/norway/login-url", { signal }).then((response) => response.data);
}
async function initPrivateDenmarkLogin(signal) {
  return client.get("/private/denmark/login-url", { signal }).then((response) => response.data);
}
async function initPrivateFinlandLogin(signal) {
  return client.get("/private/finland/login-url", { signal }).then((response) => response.data);
}
async function norwayPrivateLogin(request, signal) {
  return client.post("/private/norway/login", request, { signal }).then((response) => response.data);
}
async function denmarkPrivateLogin(request, signal) {
  return client.post("/private/denmark/login", request, { signal }).then((response) => response.data);
}
async function finlandPrivateLogin(request, signal) {
  return client.post("/private/finland/login", request, { signal }).then((response) => response.data);
}
async function getAuthStatus(id, signal) {
  return client.get(`/private/auth/${id}`, { signal }).then((response) => response.data);
}
async function swedenPrivateAuth(id, signal) {
  return client.post(`/private/sweden/auth/${encodeURIComponent(id)}`, {}, { signal }).then((response) => response.data);
}
async function getPrivateAuthResult(id, signal) {
  return client.get(`/private/sweden/auth/${encodeURIComponent(id)}`, { signal }).then((response) => response.data);
}
async function initPrivateNorwayAuth(id, signal) {
  return client.get(`/private/auth/norway/${encodeURIComponent(id)}/url`, {
    signal
  }).then((response) => response.data);
}
async function initPrivateDenmarkAuth(id, signal) {
  return client.get(`/private/auth/denmark/${encodeURIComponent(id)}/url`, {
    signal
  }).then((response) => response.data);
}
async function initPrivateFinlandAuth(id, signal) {
  return client.get(`/private/auth/finland/${encodeURIComponent(id)}/url`, {
    signal
  }).then((response) => response.data);
}
async function norwayPrivateAuth(id, request, signal) {
  return client.post(`/private/auth/norway/${encodeURIComponent(id)}`, request, { signal }).then((response) => response.data);
}
async function denmarkPrivateAuth(id, request, signal) {
  return client.post(`/private/auth/denmark/${encodeURIComponent(id)}`, request, {
    signal
  }).then((response) => response.data);
}
async function finlandPrivateAuth(id, request, signal) {
  return client.post(`/private/auth/finland/${encodeURIComponent(id)}`, request, {
    signal
  }).then((response) => response.data);
}
async function validatePrivateUserEmail(code, signal) {
  return client.post("/private/email/validate", null, {
    params: { code },
    signal
  });
}
async function getScheduledMaintenance(signal) {
  return client.get("/scheduled-maintenance/upcoming", {
    signal
  }).then((response) => response.data);
}
async function startTeleIdLogExcelExport(signal) {
  return client.post("/teleid/excel-export", null, { signal }).then((response) => response.data);
}
async function getTeleIdLogExcelExport(id, signal) {
  return client.get(`/teleid/excel-export/${id}`, { signal }).then((response) => response.data);
}
async function getTeleIdLogExcelExportResult(id, signal) {
  return client.get(`/teleid/excel-export/${id}/result`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function deleteTeleIdLog(signal) {
  return client.delete("/teleid", { signal }).then((response) => response.data);
}
async function startTeleSignLogExcelExport(signal) {
  return client.post("/telesign/excel-export", null, { signal }).then((response) => response.data);
}
async function getTeleSignLogExcelExport(id, signal) {
  return client.get(`/telesign/excel-export/${id}`, { signal }).then((response) => response.data);
}
async function getTeleSignLogExcelExportResult(id, signal) {
  return client.get(`/telesign/excel-export/${id}/result`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function startTeleSignPdfExport(signal) {
  return client.post("/telesign/pdf-export", null, { signal }).then((response) => response.data);
}
async function getTeleSignPdfExport(id, signal) {
  return client.get(`/telesign/pdf-export/${id}`, { signal }).then((response) => response.data);
}
async function getTeleSignPdfExportResult(id, signal) {
  return client.get(`/telesign/pdf-export/${id}/result`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
async function deleteTeleSignLog(signal) {
  return client.delete("/telesign", { signal }).then((response) => response.data);
}
async function getProducts(signal) {
  return client.get(`/admin/invoice/product`, { signal }).then((response) => response.data);
}
async function createOrder(request, signal) {
  return client.post(
    `/admin/invoice/order`,
    {
      ...request,
      costs: request.costs.map((cost) => ({
        ...cost,
        startDate: (cost == null ? void 0 : cost.startDate) ? dayjs(cost.startDate).format("YYYY-MM-DD") : void 0,
        endDate: (cost == null ? void 0 : cost.endDate) ? dayjs(cost.endDate).format("YYYY-MM-DD") : void 0
      }))
    },
    { signal }
  ).then((response) => response.data);
}
async function deleteInboxMessage(messageId, signal) {
  return client.delete(`/enduser/message/${messageId}`, { signal }).then((response) => response.data);
}
async function forwardInboxMessage(messageId, signal) {
  return client.post(`/enduser/message/${messageId}/forward`, { signal }).then((response) => response.data);
}
async function getInboxMessages(signal) {
  return client.get("/enduser/message", { signal }).then((response) => response.data);
}
async function getInboxMessageSigners(messageId, signal) {
  return client.get(`/enduser/message/${messageId}/signers`, { signal }).then((response) => response.data);
}
async function markInboxMessageAsRead(messageId, signal) {
  return client.post(`/enduser/message/${messageId}/read`, null, { signal }).then((response) => response.data);
}
async function signInboxMessage(messageId, signal) {
  return client.post(`/enduser/message/${messageId}/sign`, null, { signal }).then((response) => response.data);
}
async function getSignInboxMessageResult(messageId, ref, signal) {
  return client.get(`/enduser/message/${messageId}/result/${ref}`, { signal }).then((response) => response.data);
}
async function getInboxAttachment(messageId, token, signal) {
  return client.get(`/attachment/enduser/${messageId}`, {
    responseType: "blob",
    params: {
      token
    },
    signal
  }).then((response) => response.data);
}
async function downloadInboxTeleSignPdf(messageId, signal) {
  return client.get(`/enduser/message/${messageId}/pdf`, {
    responseType: "blob",
    signal
  }).then((response) => response.data);
}
var FormPropertyType = /* @__PURE__ */ ((FormPropertyType2) => {
  FormPropertyType2["CHECKBOX"] = "CHECKBOX";
  FormPropertyType2["SELECT"] = "SELECT";
  FormPropertyType2["MULTI_SELECT"] = "MULTI_SELECT";
  FormPropertyType2["RADIO_BUTTON_GROUP"] = "RADIO_BUTTON_GROUP";
  FormPropertyType2["TEXT_AREA"] = "TEXT_AREA";
  FormPropertyType2["FILE"] = "FILE";
  FormPropertyType2["TEXT"] = "TEXT";
  return FormPropertyType2;
})(FormPropertyType || {});
async function getGdprFormByOrigin(signal) {
  return client.get("/formid", {
    signal
  }).then((response) => response.data);
}
async function getGdprFormByName(formName, companyCode, signal) {
  return client.get(`/formid/${formName}`, {
    params: {
      companyCode
    },
    signal
  }).then((response) => response.data);
}
async function getFormByCode(companyCode, formName, signal) {
  return client.get(`/admin/form/company/${companyCode}/form/${formName}`, {
    signal
  }).then((response) => response.data);
}
async function getFormsByCompany(signal) {
  return client.get("/message/gdpr", { signal }).then((response) => response.data);
}
async function updateForm(companyCode, data, signal) {
  return client.post(`/admin/form/company/${companyCode}`, data, { signal }).then((response) => response.data);
}
async function updateFormFont(formId, file, signal) {
  const data = new FormData();
  data.append("file", file);
  return client.put(`/admin/form/${formId}/font`, data, { signal }).then((response) => response.data);
}
async function postForm(formName, companyCode, form, token, signal) {
  const data = new FormData();
  for (const [key, value] of Object.entries(form)) {
    if (value instanceof File) {
      data.append(key, value);
    } else if (value !== void 0 && value !== null) {
      data.append(key, String(value));
    }
  }
  return client.post(`/formid/${formName}`, data, {
    headers: {
      Authorization: `Basic ${window.btoa(`${token}:${token}`)}`
    },
    params: {
      companyCode
    },
    signal
  }).then((response) => response.data);
}
async function getOwnEndUser(signal) {
  return client.get("/enduser/me", { signal }).then((response) => response.data);
}
async function updateOwnEndUserEmail(email, signal) {
  return client.put("/enduser", { email }, { signal }).then((response) => response.data);
}
async function deleteOwnEndUser(signal) {
  return client.delete("/enduser/me", { signal }).then((response) => response.data);
}
async function validateEndUserEmail(code, signal) {
  return client.post("/enduser/email/validate", null, {
    params: { code },
    signal
  });
}
var EncryptionLevel = /* @__PURE__ */ ((EncryptionLevel2) => {
  EncryptionLevel2[EncryptionLevel2["NONE"] = 0] = "NONE";
  EncryptionLevel2[EncryptionLevel2["SINGLE"] = 1] = "SINGLE";
  EncryptionLevel2[EncryptionLevel2["DOUBLE"] = 2] = "DOUBLE";
  return EncryptionLevel2;
})(EncryptionLevel || {});
async function getCompanyConfig(token, signal) {
  if (token) {
    return client.get("/company/config", {
      headers: {
        Authorization: `Basic ${window.btoa(`${token}:${token}`)}`
      },
      signal
    }).then((response) => response.data);
  }
  return client.get("/company/config").then((response) => response.data);
}
async function generateApiToken(signal) {
  return client.post("/company/token", null, { signal }).then((response) => response.data);
}
async function getVersionHeaders(signal) {
  return axios.head("/", { signal }).then((response) => response.headers);
}
async function initAdminNorwayLogin(signal) {
  return client.get("/auth/admin/norway/login-url", { signal }).then((response) => response.data);
}
async function initAdminFinlandLogin(signal) {
  return client.get("/auth/admin/finland/login-url", { signal }).then((response) => response.data);
}
async function initAdminDenmarkLogin(signal) {
  return client.get("/auth/admin/denmark/login-url", { signal }).then((response) => response.data);
}
async function initPortalNorwayLogin(signal) {
  return client.get("/auth/norway/portal-login-url", { signal }).then((response) => response.data);
}
async function initPortalFinlandLogin(signal) {
  return client.get("/auth/finland/portal-login-url", { signal }).then((response) => response.data);
}
async function initPortalDenmarkLogin(signal) {
  return client.get("/auth/denmark/portal-login-url", { signal }).then((response) => response.data);
}
async function initInboxNorwayLogin(signal) {
  return client.get("/auth/norway/inbox-login-url", { signal }).then((response) => response.data);
}
async function initInboxFinlandLogin(signal) {
  return client.get("/auth/finland/inbox-login-url", { signal }).then((response) => response.data);
}
async function initInboxDenmarkLogin(signal) {
  return client.get("/auth/denmark/inbox-login-url", { signal }).then((response) => response.data);
}
async function initFormIdNorwayLogin(formId, signal) {
  return client.get("/auth/norway/form-login-url", { params: { formId }, signal }).then((response) => response.data);
}
async function initFormIdFinlandLogin(formId, signal) {
  return client.get("/auth/finland/form-login-url", { params: { formId }, signal }).then((response) => response.data);
}
async function initFormIdDenmarkLogin(formId, signal) {
  return client.get("/auth/denmark/form-login-url", { params: { formId }, signal }).then((response) => response.data);
}
async function swedenAdminLogin(signal) {
  return client.post("/auth/admin/login", null, { signal }).then((response) => response.data);
}
async function norwayAdminLogin(request, signal) {
  return client.post("/auth/admin/norway/login", request, { signal }).then((response) => response.data);
}
async function finlandAdminLogin(request, signal) {
  return client.post("/auth/admin/finland/login", request, { signal }).then((response) => response.data);
}
async function denmarkAdminLogin(request, signal) {
  return client.post("/auth/admin/denmark/login", request, { signal }).then((response) => response.data);
}
async function getAdminLoginResult(ref, signal) {
  return client.get(`/auth/admin/result/${encodeURIComponent(ref)}`, { signal }).then((response) => response.data);
}
async function swedenPortalLogin(request, signal) {
  return client.post("/auth/login", request ?? {}, { signal }).then((response) => response.data);
}
async function norwayPortalLogin(request, signal) {
  return client.post("/auth/norway/login", request, { signal }).then((response) => response.data);
}
async function finlandPortalLogin(request, signal) {
  return client.post("/auth/finland/login", request, { signal }).then((response) => response.data);
}
async function denmarkPortalLogin(request, signal) {
  return client.post("/auth/denmark/login", request, { signal }).then((response) => response.data);
}
async function ssoPortalLogin(code, signal) {
  return client.post("/auth/sso/login", { id: code, code }, { signal }).then((response) => response.data);
}
async function getPortalLoginResult(ref, signal) {
  return client.get(`/auth/result/${encodeURIComponent(ref)}`, { signal }).then((response) => response.data);
}
async function authenticatePortal(request, signal) {
  return client.post("/auth/authenticate", request, { signal }).then((response) => response.data);
}
async function changeCompany(request, signal) {
  return client.post("/auth/authenticate/company", request, { signal }).then((response) => response.data);
}
async function swedenInboxLogin(signal) {
  return client.post(`/auth/pno/login`, null, { signal }).then((response) => response.data);
}
async function norwayInboxLogin(request, signal) {
  return client.post("/auth/norway/enduser/login", request, { signal }).then((response) => response.data);
}
async function finlandInboxLogin(request, signal) {
  return client.post("/auth/finland/enduser/login", request, { signal }).then((response) => response.data);
}
async function denmarkInboxLogin(request, signal) {
  return client.post("/auth/denmark/enduser/login", request, { signal }).then((response) => response.data);
}
async function getInboxLoginResult(ref, signal) {
  return client.get(`/auth/inbox/result/${encodeURIComponent(ref)}`, { signal }).then((response) => response.data);
}
async function swedenFormIdLogin(formId, signal) {
  return client.post(`/auth/sweden/gdprform/login`, null, { params: { formId }, signal }).then((response) => response.data);
}
async function norwayFormIdLogin(formId, request, signal) {
  return client.post("/auth/norway/gdprform/login", request, {
    params: { formId },
    signal
  }).then((response) => response.data);
}
async function finlandFormIdLogin(formId, request, signal) {
  return client.post("/auth/finland/gdprform/login", request, {
    params: { formId },
    signal
  }).then((response) => response.data);
}
async function denmarkFormIdLogin(formId, request, signal) {
  return client.post("/auth/denmark/gdprform/login", request, {
    params: { formId },
    signal
  }).then((response) => response.data);
}
async function getFormIdLoginResult(ref, signal) {
  return client.get(`/auth/sweden/gdprform/result/${encodeURIComponent(ref)}`, { signal }).then((response) => response.data);
}
async function logoutAdmin(signal) {
  return client.post("/auth/admin/logout", null, { signal }).then((response) => response.data);
}
async function logoutPortal(signal) {
  return client.post("/auth/logout", null, { signal }).then((response) => response.data);
}
async function resetPassword(username, language, signal) {
  return client.post(
    `/auth/reset-password`,
    {
      username,
      language
    },
    { signal }
  ).then((response) => response.data);
}
async function changePassword(code, password, signal) {
  return client.post(
    "/auth/change-password",
    {
      code,
      password
    },
    { signal }
  ).then((response) => response.data);
}
var AuthType = /* @__PURE__ */ ((AuthType2) => {
  AuthType2["PASSWORD"] = "PASSWORD";
  AuthType2["EID"] = "EID";
  AuthType2["SSO"] = "SSO";
  return AuthType2;
})(AuthType || {});
async function createScheduledMaintenance(request, signal) {
  return client.post("/scheduled-maintenance", request, { signal }).then((response) => response.data);
}
async function updateScheduledMaintenance(id, request, signal) {
  return client.put(`/scheduled-maintenance/${id}`, request, { signal }).then((response) => response.data);
}
async function getScheduledMaintenanceById(id, signal) {
  return client.get(`/scheduled-maintenance/${id}`, { signal }).then((response) => response.data);
}
async function getAllScheduledMaintenance(params, signal) {
  return client.get("/scheduled-maintenance", {
    params: {
      ...params,
      fromDate: (params == null ? void 0 : params.fromDate) ? dayjs(params.fromDate).format("YYYY-MM-DD") : null,
      toDate: (params == null ? void 0 : params.toDate) ? dayjs(params.toDate).format("YYYY-MM-DD") : null
    },
    signal
  }).then((response) => response.data);
}
async function deleteScheduledMaintenance(id, signal) {
  return client.delete(`/scheduled-maintenance/${id}`, { signal }).then((response) => response.data);
}
async function getCompanyById(companyId, signal) {
  return client.get(`/admin/company/${companyId}`, { signal }).then((response) => response.data);
}
async function getCompaniesSimple(signal) {
  return client.get("/admin/company/simple", { signal }).then((response) => response.data);
}
async function getCompanies(params, signal) {
  var _a, _b;
  return client.get("/admin/company", {
    params: {
      ...params,
      countries: (_a = params == null ? void 0 : params.countries) == null ? void 0 : _a.join(","),
      services: (_b = params == null ? void 0 : params.services) == null ? void 0 : _b.join(",")
    },
    signal
  }).then((response) => response.data);
}
async function createCompany(data, signal) {
  return client.post("/admin/company", data, { signal }).then((response) => response.data);
}
async function updateCompany(companyId, data, signal) {
  return client.put(`/admin/company/${companyId}`, data, { signal }).then((response) => response.data);
}
async function deleteCompany(companyId, params, signal) {
  return client.delete(`/admin/company/${companyId}`, { params, signal }).then((response) => response.data);
}
async function encryptCompany(companyId, signal) {
  return client.post(`/admin/company/${companyId}/encrypt`, null, { signal }).then((response) => response.data);
}
async function updateCompanyKeyStore(companyId, file, signal) {
  const data = new FormData();
  data.append("file", file);
  return client.put(`/admin/company/${companyId}/keystore`, data, { signal }).then((response) => response.data);
}
async function getPersmissions(signal) {
  return client.get("/admin/role/permission", { signal }).then((response) => response.data);
}
async function getAdminRoleByName(roleName, signal) {
  return client.get(`/admin/role/${roleName}`, { signal }).then((response) => response.data);
}
async function getAdminRoles(params, signal) {
  var _a;
  return client.get("/admin/role", {
    params: {
      ...params,
      permissions: (_a = params == null ? void 0 : params.permissions) == null ? void 0 : _a.join(",")
    },
    signal
  }).then((response) => response.data);
}
async function createAdminRole(request, signal) {
  return client.post("/admin/role", request, { signal }).then((response) => response.data);
}
async function updateAdminRole(roleName, request, signal) {
  return client.put(`/admin/role/${roleName}`, request, { signal }).then((response) => response.data);
}
async function deleteAdminRole(roleName, signal) {
  return client.delete(`/admin/role/${roleName}`, { signal }).then((response) => response.data);
}
async function getOwnAdminUser(signal) {
  return client.get("/admin/admin-user/me", { signal }).then((response) => response.data);
}
async function getAdminUserById(userId, signal) {
  return client.get(`/admin/admin-user/${userId}`, { signal }).then((response) => response.data);
}
async function getAdminUsers(params, signal) {
  return client.get("/admin/admin-user", { params, signal }).then((response) => response.data);
}
async function createAdminUser(request, signal) {
  return client.post("/admin/admin-user", request, { signal }).then((response) => response.data);
}
async function updateAdminUser(userId, request, signal) {
  return client.patch(`/admin/admin-user/${userId}`, request, { signal }).then((response) => response.data);
}
async function deleteAdminUser(userId, signal) {
  return client.delete(`/admin/admin-user/${userId}`, { signal }).then((response) => response.data);
}
async function adminGetPortalUserById(userId, signal) {
  return client.get(`/admin/company-user/${userId}`, { signal }).then((response) => response.data);
}
async function adminGetPortalUsers(params, signal) {
  return client.get(`/admin/company-user`, { params, signal }).then((response) => response.data);
}
async function adminGetOrCreatePortalUser(request, signal) {
  const data = request.ssn ? {
    username: request.ssn,
    country: request.country,
    authType: AuthType.EID
  } : {
    username: request.username,
    authType: AuthType.PASSWORD
  };
  const users = await adminGetPortalUsers(data);
  if (users.totalElements === 1) {
    return users.data[0];
  }
  return adminCreatePortalUser(request, signal);
}
async function adminCreatePortalUser(request, signal) {
  return client.post("/admin/company-user", request, { signal }).then((response) => response.data);
}
async function adminUpdatePortalUser(userId, request, signal) {
  return client.patch(`/admin/company-user/${userId}`, request, { signal }).then((response) => response.data);
}
async function adminDeletePortalUser(userId, signal) {
  return client.delete(`/admin/company-user/${userId}`, { signal }).then((response) => response.data);
}
async function adminAddUserToCompany(companyId, userId, request, signal) {
  return client.put(`/admin/company/${companyId}/company-user/${userId}`, request, { signal }).then((response) => response.data);
}
async function adminRemoveUserFromCompany(companyId, userId, signal) {
  return client.delete(`/admin/company/${companyId}/company-user/${userId}`, { signal }).then((response) => response.data);
}
async function getApiCustomerById(customerId, signal) {
  return client.get(`/admin/api-customer/${customerId}`, { signal }).then((response) => response.data);
}
async function getApiCustomersSimple(signal) {
  return client.get("/admin/api-customer/simple", { signal }).then((response) => response.data);
}
async function getApiCustomers(params, signal) {
  var _a;
  return client.get(`/admin/api-customer`, {
    params: {
      ...params,
      countries: (_a = params == null ? void 0 : params.countries) == null ? void 0 : _a.join(",")
    },
    signal
  }).then((response) => response.data);
}
async function createApiCustomer(data, signal) {
  return client.post("/admin/api-customer", data, { signal }).then((response) => response.data);
}
async function updateApiCustomer(customerId, data, signal) {
  return client.put(`/admin/api-customer/${customerId}`, data, { signal }).then((response) => response.data);
}
async function deleteApiCustomer(customerId, params, signal) {
  return client.delete(`/admin/api-customer/${customerId}`, { params, signal }).then((response) => response.data);
}
async function updateApiCustomerKeyStore(customerId, file, signal) {
  const data = new FormData();
  data.append("file", file);
  return client.put(`/admin/api-customer/${customerId}/keystore`, data, { signal }).then((response) => response.data);
}
async function getForms(params, signal) {
  return client.get("/admin/form", {
    params: {
      ...params,
      country: params == null ? void 0 : params.country
    },
    signal
  }).then((response) => response.data);
}
async function deleteForm(companyCode, formName, params, signal) {
  return client.delete(`/admin/form/company/${companyCode}/form/${formName}`, {
    params,
    signal
  }).then((response) => response.data);
}
async function updateFormKeyStore(formId, file, signal) {
  const data = new FormData();
  data.append("file", file);
  return client.put(`/admin/form/${formId}/keystore`, data, { signal }).then((response) => response.data);
}
export {
  AuthMethod,
  CallInitiator,
  EncryptionLevel,
  FormPropertyType,
  SafeMailStatus,
  acceptPrivateAppTermsOfServices,
  addPortalUser,
  addRecipients,
  adminAddUserToCompany,
  adminCreatePortalUser,
  adminDeletePortalUser,
  adminGetOrCreatePortalUser,
  adminGetPortalUserById,
  adminGetPortalUsers,
  adminRemoveUserFromCompany,
  adminUpdatePortalUser,
  authenticatePortal,
  cancelTeleId,
  cancelTeleSign,
  changeCompany,
  changePassword,
  changeSafeMailInboxMessageStatus,
  client,
  createAdminRole,
  createAdminUser,
  createApiCustomer,
  createAuthRequest,
  createCompany,
  createOrder,
  createScheduledMaintenance,
  deleteAdminRole,
  deleteAdminUser,
  deleteApiCustomer,
  deleteAuthRequest,
  deleteCompany,
  deleteForm,
  deleteInboxMessage,
  deleteOwnEndUser,
  deleteOwnPrivateUser,
  deletePortalUser,
  deleteSafeMailInboxMessages,
  deleteSafeMailSentMessages,
  deleteScheduledMaintenance,
  deleteTeleIdLog,
  deleteTeleSignLog,
  denmarkAdminLogin,
  denmarkFormIdLogin,
  denmarkInboxLogin,
  denmarkPortalLogin,
  denmarkPrivateAuth,
  denmarkPrivateLogin,
  downloadInboxTeleSignPdf,
  downloadTeleSignPdf,
  encryptCompany,
  exportStats,
  finlandAdminLogin,
  finlandFormIdLogin,
  finlandInboxLogin,
  finlandPortalLogin,
  finlandPrivateAuth,
  finlandPrivateLogin,
  forwardInboxMessage,
  generateApiToken,
  getAdminLoginResult,
  getAdminRoleByName,
  getAdminRoles,
  getAdminUserById,
  getAdminUsers,
  getAllScheduledMaintenance,
  getApiCustomerById,
  getApiCustomers,
  getApiCustomersSimple,
  getAuthRequests,
  getAuthStatus,
  getCompanies,
  getCompaniesSimple,
  getCompanyById,
  getCompanyConfig,
  getFormByCode,
  getFormIdLoginResult,
  getForms,
  getFormsByCompany,
  getGdprFormByName,
  getGdprFormByOrigin,
  getInboxAttachment,
  getInboxLoginResult,
  getInboxMessageSigners,
  getInboxMessages,
  getOwnAdminUser,
  getOwnEndUser,
  getOwnPortalUser,
  getOwnPrivateUser,
  getPersmissions,
  getPortalLoginResult,
  getPortalUserById,
  getPortalUsers,
  getPrivateAuthResult,
  getPrivateLoginResult,
  getProducts,
  getSafeMailInboxExcelExport,
  getSafeMailInboxExcelExportResult,
  getSafeMailInboxMessageAttachment,
  getSafeMailInboxMessages,
  getSafeMailInboxPdf,
  getSafeMailInboxPdfExport,
  getSafeMailInboxPdfExportResult,
  getSafeMailOutboxExcelExport,
  getSafeMailOutboxExcelExportResult,
  getSafeMailOutboxMessages,
  getSafeMailPopulateData,
  getSafeMailSentMessageAttachment,
  getScheduledMaintenance,
  getScheduledMaintenanceById,
  getSignInboxMessageResult,
  getStatsParams,
  getTeleIdAuthStatus,
  getTeleIdLogExcelExport,
  getTeleIdLogExcelExportResult,
  getTeleIdLogs,
  getTeleIdStatus,
  getTeleSignLogExcelExport,
  getTeleSignLogExcelExportResult,
  getTeleSignLogs,
  getTeleSignPdfExport,
  getTeleSignPdfExportResult,
  getTeleSignSigningStatus,
  getTeleSignStatus,
  getVersionHeaders,
  initAdminDenmarkLogin,
  initAdminFinlandLogin,
  initAdminNorwayLogin,
  initCheckout,
  initFormIdDenmarkLogin,
  initFormIdFinlandLogin,
  initFormIdNorwayLogin,
  initInboxDenmarkLogin,
  initInboxFinlandLogin,
  initInboxNorwayLogin,
  initPortalDenmarkLogin,
  initPortalFinlandLogin,
  initPortalNorwayLogin,
  initPrivateDenmarkAuth,
  initPrivateDenmarkLogin,
  initPrivateFinlandAuth,
  initPrivateFinlandLogin,
  initPrivateNorwayAuth,
  initPrivateNorwayLogin,
  logoutAdmin,
  logoutPortal,
  markInboxMessageAsRead,
  norwayAdminLogin,
  norwayFormIdLogin,
  norwayInboxLogin,
  norwayPortalLogin,
  norwayPrivateAuth,
  norwayPrivateLogin,
  postForm,
  resendOwnPortalUserValidationEmail,
  resendPortalUserValidationEmail,
  resetPassword,
  searchStats,
  sendMessage,
  signInboxMessage,
  ssoPortalLogin,
  startSafeMailInboxExcelExport,
  startSafeMailInboxPdfExport,
  startSafeMailOutboxExcelExport,
  startTeleId,
  startTeleIdAuth,
  startTeleIdLogExcelExport,
  startTeleSign,
  startTeleSignLogExcelExport,
  startTeleSignPdfExport,
  startTeleSignSigning,
  swedenAdminLogin,
  swedenFormIdLogin,
  swedenInboxLogin,
  swedenPortalLogin,
  swedenPrivateAuth,
  swedenPrivateLogin,
  updateAdminRole,
  updateAdminUser,
  updateApiCustomer,
  updateApiCustomerKeyStore,
  updateCompany,
  updateCompanyKeyStore,
  updateForm,
  updateFormFont,
  updateFormKeyStore,
  updateOwnEndUserEmail,
  updateOwnPortalUser,
  updateOwnPrivateUserEmail,
  updatePortalUser,
  updatePortalUserRole,
  updateScheduledMaintenance,
  validateEndUserEmail,
  validatePortalUserEmail,
  validatePrivateUserEmail
};
//# sourceMappingURL=api.js.map
